<template>
  <EmailLogin data-fn-location="login" />
</template>

<script>
import EmailLogin from '../components/templates/EmailLogin'

export default {
  components: {
    EmailLogin
  }
}
</script>
